import React from "react";
import { Box, Typography } from "@mui/material";

export function SocialTab() {
    return <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>Social</Typography>
            <form id="tab">
                <label className="labels">FaceBook Link<br/>
                    <input type="url" name="facebook"/>
                </label>
                <label className="labels">Twitter Link<br/>
                    <input type="url" name="twitter"/>
                </label>
                <label className="labels">Instagram Link<br/>
                    <input type="url" name="instagram"/>
                </label>
                <label className="labels">SnapChat Link<br/>
                    <input type="url" name="snapchat"/>
                </label>
                <button type="submit" className="save-button" value="Submit">Save</button>
            </form>
    </Box>;
}

